import {
  BirdviewTileKey,
  DashboardTileTone,
} from '../DashboardBirdview.constants'

import EmailIcon from '../../../icons/email.svg'
import ProvidersIcon from '../../../icons/providers.svg'
import ServiceRequestIcon from '../../../icons/service-request.svg'
import TaskIcon from '../../../icons/task.svg'

export const BirdviewOperationalWidget = {
  Activities: 'activities',
  Attention: 'attention',
  Communication: 'communication',
  DocFlows: 'docFlows',
  Greta: 'greta',
  Properties: 'properties',
  ServiceRequests: 'serviceRequests',
}

export const BIRDVIEW_OPERATIONAL_WIDGET_TITLE_KEY = {
  [BirdviewOperationalWidget.Activities]:
    'DashboardBirdview.MyActivitiesTitleKey',
  [BirdviewOperationalWidget.Attention]: 'DashboardBirdview.AttentionTitleKey',
  [BirdviewOperationalWidget.Communication]:
    'DashboardBirdview.MyCommunicationsTitleKey',
  [BirdviewOperationalWidget.DocFlows]: 'DashboardBirdview.DocFlowsTitleKey',
  [BirdviewOperationalWidget.Greta]: 'DashboardBirdview.GretaTitleKey',
  [BirdviewOperationalWidget.Properties]:
    'DashboardBirdview.MyPropertiesTitleKey',
  [BirdviewOperationalWidget.ServiceRequests]:
    'DashboardBirdview.MyServiceRequestsTitleKey',
}

export const BIRDVIEW_OPERATIONAL_WIDGET_INFO_KEY = {
  [BirdviewOperationalWidget.Activities]:
    'DashboardBirdview.MyActivitiesInfoKey',
  [BirdviewOperationalWidget.Attention]: 'DashboardBirdview.MyAttentionInfoKey',
  [BirdviewOperationalWidget.Communication]:
    'DashboardBirdview.MyCommunicationsInfoKey',
  [BirdviewOperationalWidget.DocFlows]: 'DashboardBirdview.DocFlowsInfoKey',
  [BirdviewOperationalWidget.Properties]:
    'DashboardBirdview.MyPropertiesInfoKey',
  [BirdviewOperationalWidget.ServiceRequests]:
    'DashboardBirdview.MyServiceRequestsInfoKey',
}

// TODO Add Greta's suggestions to the layout once their endpoint ships.
export const BIRDVIEW_OPERATIONAL_LAYOUT = {
  left: [
    BirdviewOperationalWidget.Activities,
    BirdviewOperationalWidget.ServiceRequests,
    BirdviewOperationalWidget.Properties,
    BirdviewOperationalWidget.DocFlows,
  ],
  right: [
    BirdviewOperationalWidget.Attention,
    BirdviewOperationalWidget.Communication,
  ],
}

export const BIRDVIEW_OPERATIONAL_TILES = [
  {
    Icon: TaskIcon,
    infoKey: 'DashboardBirdview.TileMyOverdueInfoKey',
    key: BirdviewTileKey.Overdue,
    labelKey: 'DashboardBirdview.TileOverdueKey',
    tone: DashboardTileTone.Success,
  },
  {
    Icon: ServiceRequestIcon,
    infoKey: 'DashboardBirdview.TileNeedsMyInputInfoKey',
    key: BirdviewTileKey.Input,
    labelKey: 'DashboardBirdview.TileNeedsMyInputKey',
    tone: DashboardTileTone.Warning,
  },
  {
    Icon: EmailIcon,
    infoKey: 'DashboardBirdview.TileUnreadEmailsInfoKey',
    key: BirdviewTileKey.Unread,
    labelKey: 'DashboardBirdview.TileUnreadEmailsKey',
    tone: DashboardTileTone.Info,
  },
  {
    Icon: ProvidersIcon,
    infoKey: 'DashboardBirdview.TileWithoutProviderInfoKey',
    key: BirdviewTileKey.NoProvider,
    labelKey: 'DashboardBirdview.TileWithoutProviderKey',
    tone: DashboardTileTone.Purple,
  },
]
